<app-modal [title]="activeName" class="density-lower"
[buttons]="true" >

  <div class="modal-content">

  <div class="export-actions" *ngIf="!loading">
    <app-button *ngIf="hasPermissionToExportPdf" [disabled]="isExportingPdf || !hasAccessToAnyDealer" [loading]="isExportingPdf"
      (click)="exportPdfReport()" datacy="button-export-pdf">
      <span>
        Exportar PDF
      </span>
    </app-button>

    <app-button *ngIf="hasPermissionToExportExcel" [disabled]="isExportingExcel || !hasAccessToAnyDealer" [loading]="isExportingExcel"
      (click)="exportWorksheetReport()" datacy="button-export-xlxs">
      <span>
        Exportar Excel
      </span>
    </app-button>
  </div>


  <div class="center" *ngIf="loading">
    <span> Carregando </span>
    <mat-spinner diameter="30"></mat-spinner>
  </div>

  <div class="table" *ngIf="!loading">
    <app-table [table]="table" (emitPaginatorChanged)="pageChange($event)" [timeoutActive]="true" >
    </app-table>
  </div>
</div>
  </app-modal>
